module.exports = __webpack_public_path__ + "img/cow.e65a307c.png";